export default __webpack_public_path__ + "static/anastasiaKitten-959b4569caf17cd8651b90863bc94fc9.png";